// components/NavbarSearch.tsx
import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./GlobalSearch.module.scss";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { API } from "service/Interceptor";
import { combineClasses, debounce, serverFiles } from "utils/utils";
import NO_IMAGE from "../../../images/NO_IMAGE.jpg";
import SearchIconSVG from "components/SVGComponents/SearchIconSVG";
import SpinnerLoader from "../SpinnerLoader/SpinnerLoader";

export default function GlobalSearch(props) {
  const inputRef = useRef(null);
  const containerRef = useRef(null);
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleNavigate = (aliasId) => {
    if (aliasId) {
      navigate(`/user-profile/${aliasId}`);
    }
  };

  const fetchResults = useCallback(
    debounce(async (searchTerm) => {
      if (searchTerm.trim() === "" || searchTerm.length < 3) {
        setResults([]);
        setShowDropdown(false);
        return;
      }

      try {
        setLoading(true);
        const res = await API.get(
          `/api/search?search=${searchTerm.toLowerCase()}`
        );
        const data = res?.data?.data?.userResponse || [];
        setResults(data);
        setShowDropdown(true);
      } catch (error) {
        console.error("Search failed:", error);
        setResults([]);
        setShowDropdown(false);
      } finally {
        setLoading(false);
      }
    }, 250),
    []
  );

  useEffect(() => {
    const handleKeydown = (e) => {
      if (e.ctrlKey && e.key.toLowerCase() === "k") {
        e.preventDefault();
        inputRef?.current?.focus();
      }
    };

    const handleClickOutside = (e) => {
      if (!containerRef?.current?.contains(e.target)) {
        setShowDropdown(false);
      }
    };

    window.addEventListener("keydown", handleKeydown);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("keydown", handleKeydown);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    fetchResults(query);
  }, [query]);

  return (
    <div className={combineClasses(styles.searchContainer, props.className)} ref={containerRef}>
      <div className={styles.searchInputWrapper}>
        {/* <span className={styles.searchIcon}>
        </span> */}
        <SearchIconSVG stroke="#AEB2E3" height={18} width={18} />
        <input
          type="text"
          ref={inputRef}
          placeholder="Search"
          className={styles.searchInput}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      {/* {showDropdown && (
        <div className={styles.dropdown}>
          {results?.length === 0 ? (
            <div className={styles.noResult}>No results found</div>
          ) : (
            results?.map((item, idx) => (
              <div
                key={idx}
                className={styles.dropdownItem}
                onClick={() => handleNavigate(item?.userAliasId)}
              >
                <strong>
                  {item?.firstName} {item?.lastName}
                </strong>
                <div className={styles.subText}>{item.location}</div>
              </div>
            ))
          )}
        </div>
      )} */}

      {showDropdown && (
        <div className={styles.dropdown}>
          {loading ? (
            <div className={styles.loading}>
              <SpinnerLoader />
            </div>
          ) : results?.length === 0 ? (
            <div className={styles.noResult}>No results found</div>
          ) : (
            results?.map((item, idx) => (
              <div
                key={idx}
                className={styles.dropdownItem}
                onClick={() => handleNavigate(item?.userAliasId)}
              >
                <img
                  src={serverFiles(item?.profileUrl) || NO_IMAGE}
                  alt=""
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = NO_IMAGE;
                  }}
                />
                <strong>
                  {item?.firstName || item?.companyName} {item?.lastName}
                </strong>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
